import classNames from 'classnames'
import { useSlate } from 'slate-react'

import { Button } from 'core-components/library/button'

import { CustomEditor } from '../../../interface/custom-types'

export interface IBaseButton<T> {
  format: T
  label: string
  icon: string
  disabled: boolean
  onToggle: (editor: CustomEditor, format: T, isActive: boolean) => void
  className?: string
}

interface IProps {
  callIsActive: () => boolean
}

export function BaseButton<T>(props: IProps & IBaseButton<T>) {
  const editor = useSlate()

  return (
    <Button
      className={classNames(props.className || '')}
      onClick={(e) => {
        e.preventDefault()
        props.onToggle(editor, props.format, props.callIsActive())
      }}
      title={props.label}
      active={props.callIsActive()}
      variant={'text'}
      color={'grey'}
      disabled={props.disabled}
      iconButton={props.icon}
    />
  )
}
